// extracted by mini-css-extract-plugin
export default {"cls1":"PepHThzZN5HJTRB2NGU6","cls2":"emlu102NPP88yD2KB6Cs PepHThzZN5HJTRB2NGU6"};